export default function DeleteControlConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  controlDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete($event) {
    loaderService.showViewLoader = true;
    return controlDataService.deleteCustomerControl(vm.control.customerControlId)
      .then(() => {
        alerts.success(`The control "${vm.control.name}" was successfully deleted.`);
        $rootScope.$broadcast('refreshControlType', { customerControlTypeId: vm.control.customerControlTypeId });
        if (vm.risk) {
          vm.risk.control = vm.control;
          vm.risk.action = 'delete';
        }
        $rootScope.$broadcast('refreshRiskControls', { risk: vm.risk });
        _closeDialog($event);
      }).catch(() => {
        alerts.error('An error occurred while deleting the control.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.controlAdmin.deleteControlConfirmDialog);
  }
}

DeleteControlConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'controlDataService',
  'loaderService',
  'ssDialogService'
];
